"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordSnapshotRetrievalStrategy = void 0;
var RecordSnapshotRetrievalStrategy;
(function (RecordSnapshotRetrievalStrategy) {
    RecordSnapshotRetrievalStrategy["SINGLE_SOURCE_WATERFALL_HIGHEST_RECORD_COUNT"] = "SINGLE_SOURCE_WATERFALL_HIGHEST_RECORD_COUNT";
})(RecordSnapshotRetrievalStrategy || (exports.RecordSnapshotRetrievalStrategy = RecordSnapshotRetrievalStrategy = {}));
